export default __webpack_public_path__ + "static/core-og-image-55e7f0192272ae1ae8c10356a5d3b585.jpg";